import { useCallback, useState } from 'react';


export default function useStorage<T>(key:string):[T,(T)=>void,()=>void] {
  
  const [state, setState] = useState<T>(() => storage.get<T>(key) as any);

  const set = useCallback(newValue => {
    storage.set(key, newValue);
    setState(newValue);
  }, [key]);

  const remove = useCallback(() => {
    storage.remove(key);
    setState(null as any);
  }, [key]);

  return [state, set as any, remove];
}

export const storage = {
  set: (key: string, value) => localStorage.setItem(AppName(key), JSON.stringify(value)),
  get: <T>(key: string) => {
    const item = localStorage.getItem(AppName(key));
    if (item) return JSON.parse(item) as T;
    return null;
  },
  remove: (key: string) => {
    localStorage.removeItem(AppName(key));
  }
};


export function AppName(key) {
  return '@PainelInfor:'+key
}